(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zz-simple-bundles-de"] && !Shopify.designMode) return;
  try {
    (() => {
  function start() {
    const configElement = document.getElementById('zz-simple-bundles-i18n');
    if (!configElement || configElement.dataset.initialized === 'true') return;
    configElement.dataset.initialized = 'true';
    const config = JSON.parse(configElement.textContent);
    const targetSelector = [
      '.byob-cta',
      '.byob-resource__remove-text',
      '.byob-resource__title',
      '.byob-mini-cart__checkout',
      '.byob-mini-cart__subtotal-label',
      '.byob-options-modal__details-link',
      '.byob-mini-cart__branding',
      '.byob-mini-cart h2',
      '.byob-options-modal label'
    ].join(',');
    const attributes = ['aria-label', 'title', 'placeholder'];
    const observerOptions = {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: attributes
    };
    let widget = null;
    let widgetObserver = null;
    let queued = false;

    function translated(value) {
      const key = value.trim();
      let result = Object.prototype.hasOwnProperty.call(config.text, key)
        ? config.text[key] : null;
      const quantity = /^Add\s+(\d+)\s+more$/.exec(key);
      if (quantity) result = config.remaining.replace('[count]', quantity[1]);
      if (result === null || result === key) return value;
      return value.match(/^\s*/)[0] + result + value.match(/\s*$/)[0];
    }

    function translateWidget() {
      if (!widget || !widget.isConnected) return;
      widgetObserver.disconnect();
      try {
        widget.querySelectorAll(targetSelector).forEach(element => {
          const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            if (node.parentElement.closest('script,style,textarea,select,[contenteditable="true"]')) continue;
            const next = translated(node.nodeValue);
            if (next !== node.nodeValue) node.nodeValue = next;
          }
        });
        const labeled = [
          widget,
          ...widget.querySelectorAll('[aria-label],[title],[placeholder]')
        ];
        labeled.forEach(element => {
          attributes.forEach(attribute => {
            const value = element.getAttribute(attribute);
            if (value === null) return;
            const next = translated(value);
            if (next !== value) element.setAttribute(attribute, next);
          });
        });
      } finally {
        widgetObserver.observe(widget, observerOptions);
      }
    }

    function scheduleTranslation() {
      if (queued) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        translateWidget();
      });
    }

    function connectWidget() {
      const next = document.getElementById('byob-app-embed-wrapper');
      if (next === widget) return;
      if (widgetObserver) widgetObserver.disconnect();
      widget = next;
      if (!widget) return;
      widgetObserver = new MutationObserver(scheduleTranslation);
      translateWidget();
    }

    new MutationObserver(connectWidget).observe(document.body, {
      childList: true,
      subtree: true
    });
    connectWidget();
    window.addEventListener('pageshow', connectWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
